import * as yup from 'yup'

export class ExpiredCodeError extends Error {
  constructor(message = '') {
    super(message)
    this.name = 'ExpiredCodeError'
    this.code = 'EXPIRED_CODE'
    this.title = 'Código expirado'
    this.message = 'Solicitá uno nuevo para continuar.'
  }
}

export class InvalidCodeError extends Error {
  constructor(message = '') {
    super(message)
    this.name = 'InvalidCodeError'
    this.code = 'INVALID_CODE'
    this.title = 'El código ingresado no es válido'
    this.message = 'Verificá e intentá nuevamente.'
  }
}

export class ServiceUnavailableError extends Error {
  constructor(message = '') {
    super(message)
    this.name = 'ServiceUnavailableError'
    this.code = 'SERVICE_UNAVAILABLE'
    this.title = 'No pudimos enviar el código'
    this.message = 'Intentá nuevamente en unos minutos.'
  }
}
export class InternalError extends Error {
  constructor(message = '') {
    super(message)
    this.name = 'InternalError'
    this.code = 'INTERNAL_ERROR'
    this.title = 'Error interno del servidor'
    this.message = 'Intentá nuevamente en unos minutos.'
  }
}

export const verificarCodigoSchema = yup.object().shape({
  code: yup
    .number()
    .nullable()
    .typeError('El código no es válido. Verificá y reintentá')
    .test('has-not-errors', async (value, ctx) => {
      if (value === 123456 && ctx.options.context.timeLeft <= 0) {
        throw new ExpiredCodeError()
      }

      if (value === 654321) {
        throw new InvalidCodeError()
      }

      if (value === 111111) {
        throw new ServiceUnavailableError()
      }

      return true
    }),
})
